import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-aceessidentifier/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
resetAction as SubjectSeletcedReset
} from 'one-state-subjectselected/src/actions';

import {
resetAction as SourceSelectedReset
} from 'one-state-sourceselected/src/actions'

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    GETIDENTIFIER_FETCH = "one-state-accessidentifier/fetch"
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of GetSession
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchAccessIdentifierEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            servers,
            epicendpoints: {
                accessidentifier, apitoken
            },
            uisettings: {
                dashboardapiconfig: {
                    getsession: getsessionApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETIDENTIFIER_FETCH),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;

                const callGetAccessIdentifierAPI = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let responsefromAPI;
                        if (finesse_proxy_service) {
                            responsefromAPI = InvokeFinesseProxy(accessidentifier + "?account_id=" + (datares?.id)
                                , "", apitoken, locations, log, 'GET', alertnotification);

                        } else {
                            responsefromAPI = server.get({
                                headers: headers,
                                path: accessidentifier + "?account_id="+(datares?.id)+ "&AccountIDType=EXTERNAL"
                            })
                                .then((responsegetsession: any) => responsegetsession)
                                .catch((getsessionres: any) => {
                                    log.error(
                                        "ccw-gadget,getsession-epic",
                                        "getsession-epic", {
                                        getsessionres
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "GetAccessIdentifier",
                                        type: "error",
                                        status: getsessionres?.status,
                                        erroritems: getsessionres?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,getsession-epic",
                                "getsession-epic response", {
                                responsefromAPI
                            });
                        }
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                if (!getsessionApi) return []
                return callGetAccessIdentifierAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            let actions:any =[]
                            if (responseAfterTransform.getidentifier?.length >= 0) {

                                    actions= [
                                        setAction(responseAfterTransform.getidentifier)
                                    ];
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
export const clearGetSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, getsession-epic",
            "clear-getsession-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSubSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSub-epic",
            "clear-selectedSub-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SubjectSeletcedReset())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSourceSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSource-epic",
            "clear-selectedSource-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SourceSelectedReset())
        )

    }
);